import { logWarn, type Maybe } from '@amazon/vinyl-util'
import { type PlayableEntity } from '@/service/fragments/playableEntityFrag'
import type { PlaylistEntry } from '@/playback/PlaylistController'
import { trackToPlaylistEntry } from '@/track/trackGqlUtil'
import { podcastEpisodeToPlaylistEntry } from '@/podcast/podcastEpisodeGqlUtil'
import { ctx } from '@/util/context'

const { target } = ctx('playableEntityToPlaylistEntry')

// TODO: handle 'Advertisement' | 'Audiobook' | 'Interlude'

export function playableEntityToPlaylistEntry(
    element: Maybe<
        PlayableEntity | { __typename: 'Advertisement' | 'Audiobook' | 'Interlude' | null }
    >
): PlaylistEntry | null {
    if (element?.__typename === 'Track') {
        return trackToPlaylistEntry(element)
    } else if (element?.__typename === 'PodcastEpisode') {
        return podcastEpisodeToPlaylistEntry(element)
    } else {
        logWarn(target, 'Unhandled type:', element?.__typename)
        return null
    }
}
